import { makeStyles } from '@mui/styles';
export const useDrawerNavStyles = makeStyles((theme) => ({
  dnWrapper: {
    display: 'none',
    position: 'realtive',
    width: '100vw',
    height: '100%',
    padding: '25px 20px',
    background: theme.palette.secondary.main,
    boxShadow: '-5px 4px 8px rgba(0, 0, 0, 0.15)',
    zIndex: 9999,

    [theme.breakpoints.down('lg')]: {
      display: 'block',
    },
  },

  brandLogo: {
    overflow: 'hidden',
    height: '45px',
    [theme.breakpoints.down('lg')]: {
      height: '45px',
    },

    '& .img-logo': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      objectPosition: 'left',
    },
  },

  dnClose: {
    position: 'absolute',
    textAlign: 'center',
    right: '20px',
    top: '25px',
  },

  dnLinks: {
    color: theme.palette.text.main,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    rowGap: '40px',
    paddingLeft: 0,
  },
}));
